import { httpClient } from "../../httpClient";
import { SystemType } from "../../../store";

type Payload = {
  name: string;
  isActive: boolean;
};

type Data = any;

export async function getSystemTypes(): Promise<any> {
  try {
    const { data } = await httpClient.get(`/api/v1/business-units`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postSystemType(payload: Payload): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(
      `/api/v1/business-units`,
      payload
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function editSystemType(
  id: SystemType["id"],
  payload: Payload
): Promise<boolean> {
  try {
    const response = await httpClient.put(
      `/api/v1/business-units/${id}`,
      payload
    );

    return response.status === 200;
  } catch (error) {
    throw error;
  }
}

export const systemtype = {
  getSystemTypes,
  postSystemType,
  editSystemType,
};
